import { FormFieldData } from '@/components/FormField/formfield.models';
import { AppointmentType } from '@/utils/api';

export interface ContactFormFields extends Record<string, FormFieldData> {
  salutation: FormFieldData;
  firstname: FormFieldData;
  lastname: FormFieldData;
  mail: FormFieldData;
  phone: FormFieldData;
  street: FormFieldData;
  number: FormFieldData;
  zip: FormFieldData;
  city: FormFieldData;
  countryCode: FormFieldData;
  message: FormFieldData;
  eosum: FormFieldData;
  landAvailable: FormFieldData;
  landFieldNumber: FormFieldData;
  landCity: FormFieldData;
  landZip: FormFieldData;
}

export enum ContactType {
  Appointment = AppointmentType.CONSULATIONAPPOINTMENT,
  Offer = AppointmentType.OFFERREQUEST
}
